import { cloneDeep, omit } from 'lodash';

export const baseResourceOptions = {
  transientAttrsFn: <SidekickThreads>(endpoint: Partial<SidekickThreads>): SidekickThreads =>
    omit(cloneDeep(endpoint), ['createdAt', 'updatedAt']) as SidekickThreads,
  transformDataBeforeStore: <SidekickThread>(data: unknown): SidekickThread[] =>
    unescapeHTML((data as { data: SidekickThread[] }).data),
  additionalRequestParams: (state: unknown) => {
    const customerId = (state as { sidekickConfiguration }).sidekickConfiguration.value.v1CustomerId;
    return { customerId };
  },
};

export function unescapeHTML(input) {
  // Helper function to unescape HTML entities in a string
  const unescapeString = str => {
    const textArea = document.createElement('textarea');
    textArea.innerHTML = str;
    return textArea.value;
  };

  // Recursive function to unescape HTML entities for all strings in an object or array
  const unescapeRecursively = obj => {
    if (typeof obj === 'string') {
      // Base case: unescape string
      return unescapeString(obj);
    } else if (Array.isArray(obj)) {
      // Recursive case for arrays: apply function to each element
      return obj.map(unescapeRecursively);
    } else if (typeof obj === 'object' && obj !== null) {
      // Recursive case for objects: apply function to each value
      const result = {};
      for (const [key, value] of Object.entries(obj)) {
        result[key] = unescapeRecursively(value);
      }
      return result;
    }
    // Return non-string and non-iterable types as is
    return obj;
  };

  return unescapeRecursively(input);
}

export const escapeString = (str: string): string => {
  const textArea = document.createElement('textarea');
  textArea.textContent = str;
  return textArea.innerHTML;
};
